export default function sanitizePhone(phoneNumber: string): string {
  // Remove all non-digit characters
  let digits = phoneNumber.replace(/\D/g, '');

  // Check if country code is already present
  if (!digits.startsWith('34')) {
    // Add Spain's country code if not present
    digits = '34' + digits;
  }

  return '+' + digits;
}
